import toast from 'react-hot-toast'
import * as Sentry from '@sentry/react'

export function handleError(error: unknown) {
  Sentry.captureException(error)
  console.error(error)
}

export function handleGenericError({
  title = 'An unexpected error occurred',
  error,
}: {
  title?: string
  error: unknown
}) {
  Sentry.captureException(error)

  let errorMessage = 'Please try again later.'

  if (error instanceof Error) {
    errorMessage = error.message
  } else if (typeof error === 'string') {
    errorMessage = error
  }

  console.error(`Error! ${title}\n${errorMessage}`)
  toast.error(`${title}: ${errorMessage}`)
}

export function withErrorHandling<Args extends unknown[], R>(
  fn: (...args: Args) => R,
): (...args: Args) => Promise<Awaited<R>> {
  return async (...args: Args): Promise<Awaited<R>> => {
    try {
      const result = fn(...args)
      return await result
    } catch (error) {
      handleGenericError({ error })
      throw error
    }
  }
}

export function handleResponseError({
  title,
  status,
  error,
}: {
  error: { error: string } | undefined
  status: number
  title: string
}) {
  if (status >= 500) {
    return handleGenericError({
      title,
      error: error,
    })
  }

  return handleGenericError({
    title,
    error: error?.error,
  })
}
